import React from 'react';
import { Config } from '@leverege/plugin';
import { NumericInput, Pane, Text } from '@leverege/ui-elements';
import EditorUtil from "./EditorUtil.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const opts = {
  table: {
    embed: true,
    isRenderer: false
  },
  detail: {
    embed: true,
    isRenderer: false
  }
};
export default {
  valueType: 'percent',
  getOptions: usage => {
    return Config.get('AttributePercentEditor', usage, opts[usage]);
  },
  create: opts => {
    const {
      usage,
      style,
      context,
      attribute,
      canSet,
      editable,
      ...options
    } = opts;
    const variant = EditorUtil.getVariant(usage, 'percent', 'editor');
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:rowSCenter",
      variant: variant,
      children: [/*#__PURE__*/_jsx(NumericInput, {
        ...options,
        style: style // This makes it follow colorizers
        ,
        variant: variant,
        autoFocus: usage !== 'form',
        onDoubleClick: stopProp,
        float: true
      }), /*#__PURE__*/_jsx(Text, {
        variant: variant,
        children: "%"
      })]
    });
  }
};
function stopProp(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}